import React from 'react';
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
} from '@mui/material';
import { Link } from 'react-router-dom';

const HomePage = ({ productList, loading, error }) => {
  const fallbackImage = "path_to_default_fallback_image.jpg";

  return (
    <Box sx={{ width: '100%', padding: 3 }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography variant="h6" color="error" sx={{ mt: 4 }}>
          {error}
        </Typography>
      ) : productList.length > 0 ? (
        <Grid container spacing={3}>
          {productList.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Box
                component={Link}
                to={`/${product.product_ean}`}
                sx={{
                  textDecoration: 'none',
                  border: '1px solid #ddd',
                  borderRadius: 2,
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: 3,
                  },
                }}
              >
                <img
                  src={product.image_url1 || fallbackImage}
                  alt={product.product_name}
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: 200,
                    objectFit: 'cover',
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    padding: 2,
                    fontWeight: 600,
                    color: '#333',
                  }}
                >
                  {product.product_name || 'Unnamed Product'}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="h6" color="textSecondary" sx={{ mt: 4 }}>
          No products available.
        </Typography>
      )}
    </Box>
  );
};

export default HomePage;
